import { IDropLineProps } from './types'
import * as Styled from './styled'
import { memo } from 'react'
import { useDroppable } from '@dnd-kit/core'
import DndItem from './DndItem'

const DropLine = ({ lineIndex, items, ...props }: IDropLineProps) => {
  const { setNodeRef } = useDroppable({
    id: lineIndex
  })

  return (
    <Styled.DropLine
      {...props}
      ref={setNodeRef}
      $isVisible
      data-drop-line-index={lineIndex}
    >
      {items.map(item => (
        <DndItem key={item.id} data={item} />
      ))}
      <Styled.DropIndicator
        data-line-index={lineIndex}
        className="drop-indicator"
      />
    </Styled.DropLine>
  )
}

export default memo(DropLine)
